<template>
  <v-container fluid class="pa-6 pa-md-8">
    <div class="form-wrap">
      <Breadcrumbs
        :items="[
          {
            text: 'All Students',
            disabled: false,
            href: `/admin/schools/${$route.params.id}/students?name=${$route.query.name}`
          },
          {
            text: !!$route.query.id ? 'Edit Student' : 'Add Student',
            disabled: true
          }
        ]"
      />
      <div class="page-head mt-2 d-flex align-center">
        <div>
          <h1 class="page-head__title">
            {{ !!$route.query.id ? "Edit Student Details" : "New Student" }}
          </h1>
          <p class="page-head__sub">
            {{
              !!$route.query.id
                ? "Update this student's details."
                : "Register a new student."
            }}
          </p>
        </div>
        <v-progress-circular
          v-if="isPageLoading"
          indeterminate
          color="primary"
          size="24"
          width="3"
          class="ml-4"
        />
      </div>

      <div class="form-card">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(addNewStudent)">
            <ValidationProvider rules="required" v-slot="{ errors }">
              <v-text-field
                label="Full Student Name"
                outlined
                v-model="student.name"
                hint="Enter full student's name"
                :error-messages="errors[0]"
              />
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <v-text-field
                label="ID Number"
                outlined
                v-model="student.idNumber"
                hint="Enter student's ID Number"
                :error-messages="errors[0]"
              />
            </ValidationProvider>

            <div class="form-actions">
              <v-btn
                :disabled="isLoading"
                :loading="isLoading"
                color="primary"
                depressed
                type="submit"
                class="text-none save-btn"
              >
                Save
              </v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { numeric, required, email, min, max } from "vee-validate/dist/rules";
import SnackBarMixins from "../../../../mixins/SnackBarMIxins";
import { loadComponent } from "@/utils/helpers";
import { mapGetters } from "vuex";
extend("required", {
  ...required,
  message: `Field is required`
});
extend("numeric", {
  ...numeric,
  message: `Field only accept only numeric characters`
});
extend("min", {
  ...min,
  message: "Invalid input provided"
});
extend("max", {
  ...max,
  message: "Invalid input provided"
});
extend("email", {
  ...email,
  message: `Invalid email address provided`
});
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    SnackBar: loadComponent(`component/SnackBar`),
    Breadcrumbs: loadComponent(`component/Breadcrumbs`)
  },
  computed: {
    ...mapGetters({
      isLoading: "getIsLoading",
      isPageLoading: "getIsPageLoading",
      details: "schools/getDetails"
    })
  },
  mixins: [SnackBarMixins],
  data() {
    return {
      menu: false,
      date: null,
      activePicker: null,
      pin: {
        newPin: "",
        confirmPin: ""
      },
      show: false,
      student: {
        idNumber: "",
        name: ""
      }
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    details(payload) {
      this.student = {
        name: payload.name,
        idNumber: payload.idNumber
      };
    }
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    addNewStudent() {
      if (this.$route.query.id && this.$route.query.action) {
        let payload = {
          body: {
            ...this.student
          },
          schoolId: this.$route.params.id ?? this.details?.schoolId ?? "",
          _id: this.$route.query.id ?? this.details._id ?? "",
          schoolName: this.details?.schoolId?.name ?? ""
        };
        this.$store.dispatch("schools/updateStudentDetails", payload);
        return;
      }
      this.$store.dispatch("schools/addNewStudent", {
        schoolId: this.$route.params.id,
        schoolName: this.$route.query?.name,
        ...this.student
      });
    }
  },
  created() {
    if (this.$route.query.id && this.$route.query.action) {
      this.$store.dispatch("schools/getStudentDetails", {
        studentId: this.$route.query.id,
        schoolId: this.$route.params.id
      });
    }
  }
};
</script>

<style scoped>
.save-btn {
  border-radius: var(--radius) !important;
  height: 42px !important;
  min-width: 120px;
  font-weight: 600;
}
</style>
